<template>
  <v-container id="city-list">
    <v-breadcrumbs
      v-if="isSala"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>

    <div
      :class="`${!mostrarFiltros ? 'noFilters' : ''} order-filters`"
      v-if="isFullAdmin || (config.exibirFiltro && groupsConfig.exibirFiltro)"
    >
      <div
        class="filtragem"
        @click="mostrarFiltros = true"
        v-if="!mostrarFiltros"
      >
        <div>Filtros</div>
        <div>
          <v-icon color="primary">mdi-arrow-down-drop-circle</v-icon>
        </div>
        <!-- <div v-if="mostrarFiltros">
          <v-icon large color="primary">mdi-arrow-up-drop-circle</v-icon>
        </div> -->
      </div>
      <template v-if="mostrarFiltros">
        <div v-if="!isAT" class="mb-2 order">
          <div class="options">
            <div>
              <span class="filter">Ordenar por:</span>
            </div>
            <div class="ordernation">
              <div @click="changeOrder('nome')">
                <span :class="`${field == 'nome' ? 'active' : ''} filter`">
                  <v-icon color="rgba(0, 0, 0, 0.87)" v-if="field != 'nome'"
                    >mdi-arrow-collapse-vertical</v-icon
                  >
                  <v-icon
                    color="primary"
                    v-if="field == 'nome' && descending == 1"
                    >mdi-arrow-up</v-icon
                  >
                  <v-icon
                    color="primary"
                    v-if="field == 'nome' && descending == -1"
                    >mdi-arrow-down</v-icon
                  >
                  A/Z
                </span>
              </div>
              <div @click="changeOrder('orderSelo')" v-if="isSala">
                <span :class="`${field == 'orderSelo' ? 'active' : ''} filter`">
                  <v-icon
                    color="rgba(0, 0, 0, 0.87)"
                    v-if="field != 'orderSelo'"
                    >mdi-arrow-collapse-vertical</v-icon
                  ><v-icon
                    color="primary"
                    v-if="field == 'orderSelo' && descending == 1"
                    >mdi-arrow-up</v-icon
                  >
                  <v-icon
                    color="primary"
                    v-if="field == 'orderSelo' && descending == -1"
                    >mdi-arrow-down</v-icon
                  >
                  Selo
                </span>
              </div>
              <template>
                <template
                  v-if="
                    isFullAdmin ||
                    (config.visualizarPontosMedalha &&
                      groupsConfig.visualizarPontosMedalha)
                  "
                >
                  <div @click="changeOrder('pontos')">
                    <span
                      :class="`${field == 'pontos' ? 'active' : ''} filter`"
                    >
                      <v-icon
                        color="rgba(0, 0, 0, 0.87)"
                        v-if="field != 'pontos'"
                        >mdi-arrow-collapse-vertical</v-icon
                      ><v-icon
                        color="primary"
                        v-if="field == 'pontos' && descending == 1"
                        >mdi-arrow-up</v-icon
                      >
                      <v-icon
                        color="primary"
                        v-if="field == 'pontos' && descending == -1"
                        >mdi-arrow-down</v-icon
                      >
                      Pontos
                    </span>
                  </div>

                  <div
                    v-if="!isSala && !isTur"
                    @click="changeOrder('totalMedalhas')"
                  >
                    <span
                      :class="`${
                        field == 'totalMedalhas' ? 'active' : ''
                      } filter`"
                    >
                      <v-icon
                        color="rgba(0, 0, 0, 0.87)"
                        v-if="field != 'totalMedalhas'"
                        >mdi-arrow-collapse-vertical</v-icon
                      >
                      <v-icon
                        color="primary"
                        v-if="field == 'totalMedalhas' && descending == 1"
                        >mdi-arrow-up</v-icon
                      >
                      <v-icon
                        color="primary"
                        v-if="field == 'totalMedalhas' && descending == -1"
                        >mdi-arrow-down</v-icon
                      >
                      Medalhas
                    </span>
                  </div>
                </template>
              </template>
            </div>

            <div class="text-right cadastrarLote">
              <v-btn
                v-if="
                  isFullAdmin ||
                  (config.cadastroEmLote && groupsConfig.cadastroEmLote)
                "
                @click="cadastrarEmLote()"
                color="primary"
              >
                Cadastrar em lote
              </v-btn>
              <app-modal-insert-city
                v-if="(isAdmin || isSPFespEspecial) && !isNA"
                @save="loadCities"
              ></app-modal-insert-city>
            </div>
          </div>
        </div>

        <div ref="filtroRef">
          <div>
            <span class="filter">Filtros</span>
          </div>
          <div class="d-flex filtros">
            <div>
              <v-text-field
                :label="isSala ? 'Parceiro' : isGov ? 'Projeto' : 'Município'"
                name="nome"
                type="text"
                v-model="filtro.nome"
                solo
                placeholder="Por favor, escreva o nome"
                hide-details="auto"
                @input="filterCities()"
                clearable
                class="text-field-class"
              ></v-text-field>
            </div>
            <div v-if="!isSala && !isAT && projects.length > 1">
              <app-project-combobox
                :filter="filtro"
                @projects="setProjects"
                @changeProject="filterCities()"
              ></app-project-combobox>
            </div>

            <div v-if="!isSala">
              <app-status-combobox
                :filter="filtro"
                @onChange="filterCities()"
                :solo="true"
              ></app-status-combobox>
            </div>
            <div v-if="$store.state.uf === 'MA' && !isSala">
              <combobox-Pacote
                :filter="filtro"
                @onChange="filterCities()"
              ></combobox-Pacote>
            </div>
            <div>
              <combobox-unidade-regional
                :filter="filtro"
                @onChange="filterCities()"
              ></combobox-unidade-regional>
            </div>

            <!-- <div v-if="!isSala && !isAT">
              <combobox-Temas
                :filter="filtro"
                @teste="loadMunicipiosByTema()"
              ></combobox-Temas>
            </div> -->
            <div v-if="!isSala">
              <consultores-combobox
                :filter="filtro"
                :consultores="consultores"
                @onChange="filterCities()"
              >
              </consultores-combobox>
            </div>
          </div>
        </div>
      </template>
      <div class="showMore">
        <div class="text" @click="mostrarFiltros = false" v-if="mostrarFiltros">
          <v-icon color="primary">mdi-arrow-up-drop-circle</v-icon> Menos
          Filtros
        </div>
      </div>
    </div>
    <v-row>
      <v-col
        v-for="city in paginator(cityList)"
        v-bind:key="city.municipioId"
        class="cities"
      >
        <v-card
          class="elevation-12 city"
          :to="'/cidade/' + city.municipioId + '/geral'"
        >
          <!-- img CIDADE EM BASE64 -->

          <v-img
            v-if="!isSala"
            style="height: 200px; border-radius: 0"
            v-bind:src="
              city.imagemMunicipioBlob
                ? `data:image/jpeg;base64,${city.imagemMunicipioBlob}`
                : DEFAULT_BASE_64_IMG
            "
          ></v-img>

          <v-img
            v-if="isSala"
            style="height: 200px; border-radius: 0"
            src="../../../../public/assets/img/img_sala.png"
            width="100%"
            class="black--text align-end"
          >
          </v-img>

          <v-card-title class="nome-municipio align-end">
            <v-row>
              <v-col> {{ city.nome }}</v-col>
            </v-row>
          </v-card-title>

          <v-card-text
            v-if="
              isFullAdmin ||
              (config.visualizarPontosMedalha &&
                groupsConfig.visualizarPontosMedalha)
            "
          >
            <v-row class="align-center">
              <v-col cols="auto" class="d-flex align-center">
                <v-icon class="mr-1" color="primary"> mdi-chart-bar </v-icon>
                Pontos:
                <div class="ml-2">
                  <span class="city-card-text" v-if="city.pontos">
                    {{ city.pontos }}
                  </span>
                  <span class="city-card-text" v-if="!city.pontos"> 0 </span>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="auto" class="d-flex align-center">
                <v-icon class="mr-1" color="primary"> mdi-medal </v-icon>
                Medalhas:
                <div class="ml-2">
                  <span class="city-card-text" v-if="city.totalMedalhas">
                    {{ city.totalMedalhas }}
                  </span>
                  <span class="city-card-text" v-if="!city.totalMedalhas">
                    0
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto">
                <span class="city-card-text" v-if="!filtro.temaId">
                  {{ city.projeto.nome }}
                </span>
                <span class="city-card-text" v-else>
                  {{ city.nomeProjeto }}
                </span>
              </v-col>
            </v-row>
          </v-card-text>
          <div
            v-if="isSala"
            style="position: absolute; top: 42px; right: 0; width: 50%"
          >
            <v-col v-if="city.selo == 'Bronze'">
              <img
                src="@/assets/img/seloMedalhas/seloMedalhaBronze.png"
                style="width: 100%"
              />
            </v-col>
            <v-col v-else-if="city.selo == 'Prata'">
              <img
                src="@/assets/img/seloMedalhas/seloMedalhaPrata.png"
                style="width: 100%"
            /></v-col>
            <v-col v-else-if="city.selo == 'Ouro'">
              <img
                src="@/assets/img/seloMedalhas/seloMedalhaOuro.png"
                style="width: 100%"
              />
            </v-col>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="cityList.length === 0">
        <v-card class="px-4 py-4 no-mun" color="primary"
          >SEM {{ isGov ? "PROJETOS" : "MUNICÍPIOS" }} PARA EXIBIÇÃO</v-card
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-pagination
          v-model="page"
          :total-visible="7"
          :length="Math.ceil(cityList.length / perPage)"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertCity from "./ModalInsert";
import { cityAPI } from "@/modules/city";
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { cadastroEmLoteAPI } from "./CadastroEmLoteAPI";
import AppStatusCombobox from "./ComboboxStatusRelacionamento";
import { mapActions, mapGetters } from "vuex";
import Vue2Filters from "vue2-filters";
import { AppProjectCombobox } from "@/modules/project";
import ComboboxPacote from "./ComboboxPacote";
import ComboboxUnidadeRegional from "./ComboboxUnidadeRegional";
import ComboboxTemas from "./ComboboxTemas";
import ConsultoresCombobox from "./ComboboxConsultores";
import { userAPI } from "@/modules/user/components/UserAPI";
import {
  statusRelacionamentoEnum,
  statusRelacionamentoSeloEnum,
  statusContratoEnum,
} from "@/types";
import { DEFAULT_BASE_64_IMG } from "./defaultBase64Img";
import Pagination from "vue-pagination-2";

// import AppModalInsertCutAttendance from '@/modules/attendance/components/ModalInsertCutAttendance'

export default {
  components: {
    AppModalInsertCity,
    // AppModalInsertCutAttendance,
    AppProjectCombobox,
    AppStatusCombobox,
    ComboboxPacote,
    ComboboxUnidadeRegional,
    ComboboxTemas,
    Pagination,
    ConsultoresCombobox,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      DEFAULT_BASE_64_IMG: DEFAULT_BASE_64_IMG,
      field: "nome",
      descending: 1,
      cities: [],
      filtroRef: null,
      citiesTemas: [],
      consultores: [],
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      municipiosTemas: [],
      moreFilters: false,
      filtro: {
        nome: "",
        projetoId: 0,
        consultores: [],
      },
      projects: ["teste", "teste"],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      page: 1,
      currentPage: 0,
      perPage: 50,
      cityList: [],
      finishedMunicipio: false,
      mostrarFiltros: false,
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: true,
          to: "/",
          exact: true,
        },
      ],
    };
  },
  mounted() {
    this.loadCities();
    this.loadConsultores();
    document.getElementsByClassName("v-main__wrap")[0].style.background =
      "none";
  },
  beforeMount() {
    if (this.isParceiro) {
      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: true,
          to: "/",
          exact: true,
        },
      ];
    }
  },
  watch: {
    page: function (old, newValue) {
      this.filterCities();
    },
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "uf",
      "isNA",
      "isFullAdmin",
      "isSala",
      "isAT",
      "isTur",
      "isParceiro",
      "isGov",
    ]),
  },

  methods: {
    ...mapActions(["setLoading"]),
    getAnaliticoPorIndicador() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getAnaliticoPorIndicador()
        .then((resp) => {
          this.$notification.success("Dados Obtidos com Sucesso");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter dados");
        });
    },
    myCallback(e) {
      console.log("e: ", e);
    },
    cadastrarEmLote() {
      this.setLoading(true);
      cadastroEmLoteAPI
        .cadastrarMunicipios()
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Cadastro feito com sucesso");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao cadastrar municípios");
        });
    },

    getMunicipioVigente(item) {
      let isVigente = true;

      if (this.$store.state.uf === "RJ" && !this.isSala && !this.isAT) {
        isVigente =
          statusContratoEnum.cidadeEmpreendedora === item.statusContratoId &&
          item.statusId === statusRelacionamentoEnum.vigente;
      } else {
        isVigente =
          (this.isSala &&
            item.statusId === statusRelacionamentoSeloEnum.participante) ||
          item.statusId === statusRelacionamentoEnum.vigente;
      }

      return isVigente;
    },

    loadCities() {
      this.setLoading(true);
      cityAPI
        .list()
        .then((resp) => {
          this.cities = resp.data.map((item) => {
            if (this.isFullAdmin || this.getMunicipioVigente(item)) {
              return item;
            } else {
              return {
                ...item,
                pontos: 0,
                totalMedalhas: 0,
              };
            }
          });
          this.cities = this.cities.map((item) => {
            const selo =
              item.seloFinal &&
              item.seloFinal.length > 0 &&
              item.seloFinal[0].selo;
            return {
              ...item,
              selo: selo,
              orderSelo:
                selo == "Ouro"
                  ? 1
                  : selo == "Prata"
                  ? 2
                  : selo == "Bronze"
                  ? 3
                  : 4,
            };
          });

          this.filterCities();

          if (!this.isSala) {
            this.cityList = this.cityList.sort(this.compare);
          } else {
            this.changeOrder("orderSelo");
          }

          this.finishedMunicipio = true;
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao listar municípios");
        });
    },
    compare(a, b) {
      if (
        typeof a[this.field] === "string" &&
        typeof b[this.field] === "string"
      ) {
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return -1;
        }
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return 1;
        }
      } else {
        if (a[this.field] < b[this.field]) {
          return -1;
        }
        if (a[this.field] > b[this.field]) {
          return 1;
        }
      }
      return 0;
    },
    compareDescending(a, b) {
      if (
        typeof a[this.field] == "string" &&
        typeof b[this.field] == "string"
      ) {
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return -1;
        }
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return 1;
        }
      } else {
        if (a[this.field] > b[this.field]) {
          return -1;
        }
        if (a[this.field] < b[this.field]) {
          return 1;
        }
      }

      return 0;
    },
    compareSelo() {
      this.cityList = this.cityList.sort(function (a, b) {
        if (a.selo === b.selo) {
          if (
            a["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
            b["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            console.log("-1");
            return -1;
          }
          if (
            a["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
            b["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            console.log("1");

            return 1;
          }
        }

        if (a.pontos > b.pontos) {
          return -1;
        }
        if (a.pontos < b.pontos) {
          return 1;
        }
        return 0;
      });
    },
    compareDescendingSelo() {
      this.cityList = this.cityList.sort(function (a, b) {
        if (a.selo === b.selo) {
          if (
            a["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
            b["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            return -1;
          }
          if (
            a["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
            b["nome"].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          ) {
            return 1;
          }
        }

        if (a.pontos < b.pontos && a.selo && b.selo) {
          return -1;
        }
        if (a.pontos > b.pontos && a.selo && b.selo) {
          return 1;
        }
        return 0;
      });
    },
    changeOrder(newField) {
      // if (newField == "selo") {
      //   if (this.field !== newField) {
      //     this.descending = -1;
      //     this.page = 1;
      //     this.field = newField;
      //     this.compareSelo();
      //   } else {
      //     if (this.descending === -1) {
      //       this.page = 1;
      //       this.descending = 1;
      //       this.compareDescendingSelo();
      //     } else {
      //       this.page = 1;
      //       this.descending = -1;
      //       this.compareSelo();
      //     }
      //   }
      // } else {
      if (this.field !== newField) {
        this.descending = -1;
        this.page = 1;
        this.field = newField;
        this.cityList = this.cityList.sort(this.compare);
      } else {
        if (this.descending === -1) {
          this.page = 1;
          this.descending = 1;

          this.cityList = this.cityList.sort(this.compareDescending);
        } else {
          this.page = 1;
          this.descending = -1;
          this.cityList = this.cityList.sort(this.compare);
        }
      }
    },
    setProjects(projects) {
      this.projects = projects;
    },
    loadConsultores() {
      this.setLoading(true);
      userAPI
        .listConsultant()
        .then((resp) => {
          this.consultores = resp.data.filter(
            (item) => item.nome !== "Administrador"
          );
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao listar municípios");
        });
    },
    loadMunicipiosByTema() {
      if (this.filtro.temaId) {
        this.setLoading(true);
        cityAPI
          .getMunicipioTema(this.filtro.temaId, this.user.usuarioId)
          .then((resp) => {
            this.citiesTemas = resp.data;
            this.filterCities();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao listar municípios");
          });
      } else {
        this.filtro = {
          nome: "",
          projetoId: 0,
          consultores: [],
        };
        this.citiesTemas = [];
        this.filterCities();
      }
    },
    filterCities() {
      let cityList = this.filtro.temaId ? this.citiesTemas : this.cities;
      if (this.filtro.nome) {
        cityList = cityList.filter((item) =>
          item.nome.toLowerCase().includes(this.filtro.nome.toLowerCase())
        );
      }

      if (this.filtro.projetoId) {
        cityList = cityList.filter(
          (item) => item.projetoId === this.filtro.projetoId
        );
      }
      if (this.filtro.statusId >= 0 && this.filtro.statusId !== null) {
        cityList = cityList.filter(
          (item) => item.statusId === this.filtro.statusId
        );
      }

      if (this.filtro.pacoteId) {
        cityList = cityList.filter(
          (item) => item.pacoteId === this.filtro.pacoteId
        );
      }

      if (this.filtro.id_unidade_regional) {
        cityList = cityList.filter(
          (item) => item.id_unidade_regional === this.filtro.id_unidade_regional
        );
      }

      if (this.filtro.consultores.length > 0) {
        cityList = cityList.filter((item) =>
          this.filtro.consultores.some(
            (con) => item.consultorId === con.usuarioId
          )
        );
      }

      this.cityList = cityList;
    },
    paginator(cityList) {
      let currentPage = 0;

      if (this.finishedMunicipio && cityList.length === 0) {
        this.setLoading(false);
        return [];
      }

      if (this.page !== 1) {
        currentPage = this.perPage * (this.page - 1);
      }

      var paginatorCityList = cityList.slice(
        currentPage,
        this.page * this.perPage
      );

      paginatorCityList.length && this.setLoading(false);

      return paginatorCityList;
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";

.no-mun {
  text-align: center;
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
.cities {
  width: 300px;
  max-width: 380px;

  > a {
    border-left: 5px solid var(--corPrimaria);
    //border-right: 5px solid var(--corPrimaria);
  }

  a:hover {
    background-color: #81b2e126;
  }

  .nome-municipio,
  .city-card-text {
    color: #394d60 !important;
  }
  .city-card-text {
    font-weight: bold;
  }
}

.filtragem {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  cursor: pointer;
}
.options {
  display: flex;
  width: 100%;
  column-gap: 20px;
  flex-wrap: wrap;
}
.v-text-field--outlined {
  background: #fff;
}

.filtro-completo {
  padding-top: 1rem;
  border-top: 1px solid #c5c5c5;
  overflow: hidden;
}
.filtros {
  column-gap: 1rem;
  flex-wrap: wrap;
  row-gap: 1rem;
}
.text-field-class {
  min-width: 238px;
}
.filter {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.filter.active {
  color: var(--corPrimaria);
}

.cadastrarLote {
  margin-left: auto;
}

.noFilters {
  padding: 1rem !important;
}

.order-filters {
  background: #ededed;
  padding: 2rem 2rem 3rem 2rem;
  margin-bottom: 1rem;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}

.order {
  display: flex;
  align-content: center;
}

.ordernation {
  display: flex;
  column-gap: 20px;
}

.showMore {
  position: absolute;
  bottom: 10px;
  right: 15px;
  cursor: pointer;

  .text {
    color: var(--corPrimaria);
    display: flex;
    align-content: center;
    column-gap: 5px;
  }
}

@media screen and (max-width: 1900px) {
  .showMoreFiltro {
    height: 116px;
  }
}
@media screen and (min-width: 1900px) {
  .order-filters {
    padding: 2rem 2rem 2rem 2rem;
  }
}

@media screen and (max-width: 570px) {
  .filtros {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .cadastrarLote {
    margin: 0 auto;
  }
}
</style>
